import { Injectable } from '@angular/core';
import { BaseRequestOptionsArgs, HttpResponse, HttpService, Rest } from '@dm/core';
import { Observable } from 'rxjs';
import { RemoteAssistanceTaskParamE } from './remote-assistance.const';

@Injectable({ providedIn: 'root' })
export class RemoteAssistanceService {
    constructor(
        private http: HttpService,
    ) { }

    /**
     * 查询远程协助状态的Rest
     */
    getRemoteStatusRest(): Rest {
        return this.http.makeUrl('eService.getRemoteStatus');
    }

    /**
     * 处理远程协议
     */
    handleRemoteRequest(operate: RemoteAssistanceTaskParamE, option?: BaseRequestOptionsArgs): Observable<HttpResponse> {
        const rest = this.http.makeUrl('eService.handleRemoteRequest');
        const options: BaseRequestOptionsArgs = {
            doSuccess: true,
            ...option,
        };
        return this.http.post(rest, { responseForRemoteRequest: operate }, options);
    }
}
